module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAZCAYAAADwkER/AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNXG14zYAAAAWdEVYdENyZWF0aW9uIFRpbWUAMTAtMDYtMTiukHQ0AAAAR0lEQVQImU3JIQ4AIAwEweVIqggKW8P/f1cNxZCAuUxu6b2n5pxojIFqrSgz/1lrXe29/xARqJSCACTp6n1PADIz1FoDd88Dmb4eVu9J7YAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/top.png
// module id = 94
// module chunks = 0